import styled from 'styled-components';

import { PRIMARY, SECONDARY, ORANGE, GRAY } from 'constants/colors';

import { rSize, rSizeN } from 'components/utils';
import { brightness } from 'utils/misc';

export default styled.div`
  h2 {
    font-family: 'signikasemibold', Arial, 'sans-serif';
    font-size: ${rSize(19)};
  }

  h2,
  h3,
  h4,
  p {
    margin-top: 0;
    margin-bottom: 10px;
  }

  .planunit-selector {
    margin-bottom: 20px;
  }

  .widgets {
    display: flex;
    justify-content: space-between;
  }

  .left-side {
    width: calc(45% - ${rSize(10)});
  }

  .right-side {
    width: calc(55% - ${rSize(10)});
  }

  .open-requests {
    width: 100%;
    padding: ${rSize(10)};
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    place-self: flex-start;
    margin-bottom: ${rSize(20)};

    h2 {
      margin-bottom: ${rSize(20)};
    }

    .MuiTableContainer-root {
      width: auto;

      .is-today {
        background-color: ${brightness(ORANGE, 70)};
      }
      .is-saturday:not(.is-today) {
        background-color: ${brightness(GRAY, 70)};
      }
      .is-sunday:not(.is-today) {
        background-color: ${brightness(GRAY, 70)};
      }

      th,
      td {
        padding: 0 ${rSize(10)};
        height: ${rSize(50)};
      }

      .MuiTableHead-root {
        th {
          height: ${rSize(59)};
        }
      }

      .MuiChip-root {
        border: 0;
        width: ${rSize(30)};
        height: ${rSize(30)};

        .MuiChip-label {
          font-size: ${rSize(18)};
          text-overflow: unset;
          padding: 0;

          .icon-spinner {
            color: ${PRIMARY};
          }
        }
      }

      &:first-child {
        .MuiTableCell-body {
          width: ${rSize(220)};
        }

        button {
          text-align: left;
          display: inline-block;
          position: relative;

          &:hover {
            text-decoration: underline;
          }

          & + .icon-spinner {
            margin-left: 10px;
          }
        }
      }

      &:first-child {
        flex-grow: 1;
      }

      &:nth-child(2) {
        margin: 0 ${rSize(10)};

        .MuiTableCell-root {
          width: ${rSize(40)};
        }
      }

      &:last-child {
        .MuiTableCell-root {
          width: ${rSize(40)};
        }
      }
    }
  }

  .task-status {
    .tasks-list {
      margin: ${rSizeN(10)};

      .MuiPaper-root {
        position: relative;

        .group-icon {
          position: absolute;
          top: 8px;
          right: 8px;
          color: ${PRIMARY};
        }
      }

      &::after {
        content: '';
        display: block;
        clear: both;
      }
    }

    .MuiPaper-root {
      width: calc(100% / 3 - ${rSize(20)});
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
      padding: ${rSize(10)};
      box-sizing: border-box;
      text-align: center;
      float: left;
      margin: ${rSize(10)};

      h2 {
        margin-top: ${rSize(10)};
        margin-bottom: ${rSize(20)};
      }
    }

    .task {
      width: 100%;
      white-space: break-spaces;

      > div {
        padding: 0 ${rSize(10)};
      }
    }

    .task-name {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
    }

    .MuiChip-root {
      margin-bottom: 6px;
      border-color: transparent;
      font-size: ${rSize(28)};
    }

    .MuiBadge-badge {
      color: white;
    }

    .check-icon {
      color: ${SECONDARY};
    }
  }

  @media (max-width: 1400px) {
    .task-status {
      .MuiPaper-root {
        width: calc(50% - ${rSize(20)});
      }
    }
  }

  @media (max-width: 1100px) {
    .widgets {
      flex-direction: column;
    }
    .open-requests,
    .task-status {
      width: 100%;
    }
    .open-requests {
      margin-bottom: ${rSize(40)};
    }
  }
`;
